module.exports = __webpack_public_path__ + "img/info-octagon.c06279a4.svg";